var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiti2025(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 580 334",
    width: 580,
    height: 334,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Citi_Blue-RedArc_RGB-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #255be3 } \n\t\t.s1 { fill: #ff3c28 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m1.5 226.3c0-59.6 48.8-106 112.4-106 36.8 0 70.4 16.4 89.6 41.2l-27.6 27.6c-13.6-18-37.2-30.4-61.6-30.4-38 0-68.4 28.4-68.4 67.6 0 39.6 30.4 68 68.4 68 26.4 0 50-13.2 63.6-31.6l27.2 26.8c-18.4 26-53.6 43.2-91.2 43.2-63.6 0-112.4-46.4-112.4-106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m241.1 127.5h43.6v198h-43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m365.9 272.3v-108h-47.6v-36.8h49.6v-42.4l40.8-20v62.4h64.8v36.8h-64.8v100.8c0 20 11.2 28.8 32.4 28.8 10.8 0 21.2-2 32-6.8v37.6c-11.2 5.2-24.8 8-40 8-38.8 0-67.2-21.2-67.2-60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m507.9 127.5h43.6v198h-43.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m395.9 1.5c76 0 142 37.2 182.8 94.4h-50.8c-32.8-36.4-78.4-58.8-132-58.8-53.6 0-99.2 22.4-132 58.8h-50.8c40.8-57.2 106.8-94.4 182.8-94.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiti2025);
export default __webpack_public_path__ + "static/media/Citi-2025.6c810ac62e80bb2abb6edc7742254d16.svg";
export { ForwardRef as ReactComponent };